/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// libraries
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { useUIDSeed } from 'react-uid';
import { Link } from 'react-router-dom';
import {
    object, shape, arrayOf, string, func,
} from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { trackEvent as trackEventActions } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    title: {
        fontFamily: 'PlayfairDisplay, serif',
        fontSize: '28px',
        position: 'relative',
        textAlign: 'center',
        '&::before': {
            content: '""',
            background: '#000',
            width: '100%',
            height: '1px',
            position: 'absolute',
            right: 0,
            left: 0,
            top: '50%',
            zIndex: 1,
        },
        '& h1, h2, & h3, & h4, & h5, & h6': {
            fontSize: '30px',
            fontWeight: 'normal',
            position: 'relative',
            display: 'inline-block',
            zIndex: 9,
            background: '#FFF',
            padding: '0 30px',
        },
    },
    ourFavoriteBlockContainer: {
        maxWidth: '1400px',
        width: '100%',
        margin: '0 auto',
    },
    favInnerContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        [theme.breakpoints.down(769)]: {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
    favCard: {
        maxWidth: '378px',
        marginRight: '75px',
        borderRadius: '36px',
        boxShadow: '0px 9px 18px rgba(75,75,75,0.12)',
        textAlign: 'center',
        '&:last-child': {
            marginRight: 0,
        },
        '& img': {
            display: 'block',
            width: '100%',
            borderRadius: '36px 36px 0 0',
        },
        [theme.breakpoints.down(769)]: {
            marginRight: '20px',
            marginLeft: '20px',
            marginBottom: '30px',
            '&:last-child': {
                marginRight: '20px',
                marginBottom: 0,
            },
        },
    },
    favCardTextWrapper: {
        marginTop: '50px',
        marginBottom: '65px',
    },
    favCardTitle: {
        fontFamily: 'PlayfairDisplay, serif',
        fontSize: '28px',
        marginBottom: '10px',
    },
    favCardDesc: {
        width: '85%',
        margin: '0 auto',
        lineHeight: '20px',
        fontSize: '16px',
        marginBottom: '15px',
    },
    favCardPriceContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '20px',
        '& p': {
            margin: 0,
            marginRight: '5px',
        },
    },
    favPrice: {
        fontFamily: 'PlayfairDisplayBold, serif',
        fontSize: '24px',
        paddingBottom: '2px',
    },
    favBlockCtaBtn: {
        fontSize: 14,
        textDecoration: 'none',
        display: 'block',
        margin: '0 auto',
        width: 208,
        letterSpacing: '1.47px',
        textTransform: 'uppercase',
        borderRadius: '3px',
        border: '1px solid black',
        lineHeight: '40px',
        fontWeight: '600',
        color: '#000000',
    },
});
const OurFavoritesBlock = ({
    classes, ourFavoritesBlockData, trackEvent,
}) => {
    if (!ourFavoritesBlockData) {
        return null;
    }
    const seed = useUIDSeed();
    const ourFavoritesBlockTilesData = ourFavoritesBlockData?.tile || [];

    return (
        <div className={classes.ourFavoriteBlockContainer}>
            <div className={classes.title}><h2>{ourFavoritesBlockData?.title}</h2></div>
            <div className={classes.favInnerContainer}>
                {ourFavoritesBlockTilesData?.map((tileItem) => {
                    // for Banner Button
                    const ctaButton = tileItem?.cta_button?.title || '';
                    const ctaButtonURL = tileItem?.cta_button?.href || '';
                    return (
                        <div className={classes.favCard} key={seed(tileItem)}>
                            <img src={tileItem?.image?.url} alt="Desktop" />
                            <div className={classes.favCardTextWrapper}>
                                <div className={classes.favCardTitle}>{tileItem?.header}</div>
                                <div className={classes.favCardDesc}>{tileItem?.sub_header}</div>
                                <div className={classes.favCardPriceContainer}>
                                    <p>Starting at</p>
                                    <div className={classes.favPrice}>{tileItem?.price}</div>
                                </div>
                                {ctaButtonURL && (
                                    <Link
                                        className={classes.favBlockCtaBtn}
                                        to={ctaButtonURL}
                                        onClick={() => trackEvent({
                                            eventCategory: 'Subscriptions',
                                            eventAction: 'Our Favorites',
                                            eventLabel: tileItem?.header,
                                        })}
                                    >
                                        {ctaButton}
                                    </Link>

                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

OurFavoritesBlock.propTypes = {
    classes: object,
    ourFavoritesBlockData: shape({
        tile: arrayOf(
            shape({
                header: string,
                sub_header: string,
                text_color: string,
                tile_background_color: string,
            }),
        ),
    }),
    trackEvent: func.isRequired,
};
OurFavoritesBlock.defaultProps = {
    classes: {},
    ourFavoritesBlockData: {},
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(trackEventActions, dispatch),
});

const enhance = compose(
    connect(null, mapDispatchToProps),
    withStyles(styles),
);

export default enhance(OurFavoritesBlock);
